import React from 'react'
import { useMutation } from '@apollo/client'
import Dialog from '@/components/_custom/Dialog/Dialog'
import DialogHeader from '@/components/_custom/DialogHeader/DialogHeader'
import DialogBody from '@/components/_custom/DialogBody/DialogBody'
import styles from './detachFamilyDialog.module.scss'
import { DETACH_PARENT_MUTATION } from '@/modules/API/parent/parentAssociationHandler'
import { useTranslation } from 'react-i18next'
import ButtonTextIcon from '@/components/_custom/Buttons/ButtonTextIcon/ButtonTextIcon'
import { Close, LinkOff } from '@mui/icons-material'
import { NavigateFunction, useNavigate } from 'react-router-dom'
import { useNotification } from '@/modules/context/NotificationContext.tsx'

interface DetachFamilyDialogProps {
    open: boolean
    handleClose: () => void
    familyName: string
    familyEmail: string
    familyId: number
    daycareId: number
    isRpeOrLaep?: boolean
}

const DetachFamilyDialog: React.FunctionComponent<DetachFamilyDialogProps> = ({
    open = false,
    handleClose,
    familyId,
    familyName,
    familyEmail,
    daycareId,
    isRpeOrLaep
}) => {
    const { t } = useTranslation()

    const { showNotificationError } = useNotification()

    const navigate: NavigateFunction = useNavigate()

    const [daycareDetachParent] = useMutation(DETACH_PARENT_MUTATION, {
        variables: {
            parent_id: familyId,
            daycare_id: daycareId
        },
        onCompleted: () => {
            navigate('/adults')
        },
        onError: () => {
            showNotificationError(t('errorDetachingFamily'))
        }
    })

    return (
        <Dialog open={open} handleClose={handleClose}>
            <DialogHeader title={isRpeOrLaep ? t('deletePublic') : t('deleteFamily')} />
            <DialogBody className={styles.DialogBody}>
                <p className={styles.Text}>{isRpeOrLaep ? t('deletePublicMessage') : t('deleteFamilyMessage')}</p>
                <p className={styles.TextFamily}>
                    {familyName} {familyEmail && `- ${familyEmail}`}
                </p>
                <p className={styles.Text}>{t('noRollBack')}</p>
                <div className={styles.ButtonContainer}>
                    <ButtonTextIcon
                        type={'custom'}
                        customText={t('yes')}
                        customIcon={<LinkOff />}
                        onClick={daycareDetachParent}
                        className={styles.Button}
                    />
                    <ButtonTextIcon
                        type={'custom'}
                        customText={t('no')}
                        customIcon={<Close />}
                        onClick={handleClose}
                        className={styles.Button}
                    />
                </div>
            </DialogBody>
        </Dialog>
    )
}

export default DetachFamilyDialog
